import { enumErpIntegrado } from "../Empresa";

export class auxPossuiIntegracao{
  possuiIntegracao: boolean = false;
  integracaoRM: enumErpIntegrado = enumErpIntegrado.Nenhum;
  permissaoSincronizaEstoqueERP: boolean = false;
  ultimaSincronizacao:Date = new Date();
}
